import Modal, { Styles } from "react-modal";
import { Location } from "../../coreIdAPI";

Modal.setAppElement("#root");

const customStylesLocationDetail: Styles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "40%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};

export interface LocationDetailModalProps {
  location: Location | null | undefined;
  isOpen: boolean;
  onRequestClose: () => void;
}

const MAX_COORDINATE_DIGITS = 8;

const truncateCoordinate = (value: number): string => {
  let digitCount = 0;
  let result = "";
  for (const char of String(value)) {
    if (char >= "0" && char <= "9") {
      if (digitCount >= MAX_COORDINATE_DIGITS) break;
      digitCount++;
    }
    result += char;
  }
  return result.endsWith(".") ? result.slice(0, -1) : result;
};

const LocationRow = (props: { label: string; value: string }) => {
  return (
    <div
      className="flex-row"
      style={{
        justifyContent: "space-between",
        width: "100%",
        borderBottom: "0.5px solid rgba(0,0,0,0.2)",
      }}
    >
      <div className="text-normal text-medium" style={{ color: "black" }}>
        {props.label}
      </div>
      <div className="text-normal text-medium" style={{ color: "black" }}>
        {props.value}
      </div>
    </div>
  );
};

export const LocationDetailModal = (props: LocationDetailModalProps) => {
  const { location, isOpen, onRequestClose } = props;

  return (
    <Modal
      isOpen={isOpen}
      style={customStylesLocationDetail}
      onRequestClose={onRequestClose}
    >
      <div className="flex-col" style={{ justifyContent: "start" }}>
        <div
          className="text-large text-bold"
          style={{ textAlign: "center", color: "black", marginBottom: "10px" }}
        >
          Detalle de localización
        </div>
        {location ? (
          <>
            <LocationRow label="Dirección:" value={location.address || "No capturado"} />
            <LocationRow label="Ciudad:" value={location.locality || "No capturado"} />
            <LocationRow label="Barrio:" value={location.adminArea || "No capturado"} />
            <LocationRow
              label="Estado/Departamento:"
              value={location.state || "No capturado"}
            />
            <LocationRow label="País:" value={location.country || "No capturado"} />
            <LocationRow
              label="Código postal:"
              value={location.postalCode || "No capturado"}
            />
            <LocationRow
              label="Latitud:"
              value={
                location.lat || location.lat === 0
                  ? truncateCoordinate(location.lat)
                  : "No capturado"
              }
            />
            <LocationRow
              label="Longitud:"
              value={
                location.lon || location.lon === 0
                  ? truncateCoordinate(location.lon)
                  : "No capturado"
              }
            />
          </>
        ) : (
          <div
            className="flex-col text-normal text-medium"
            style={{
              color: "black",
              textAlign: "center",
              padding: "20px 0",
            }}
          >
            Usuario no permitió validar localización
          </div>
        )}
        <div
          className="flex-row"
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              onRequestClose();
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "20%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Cerrar
          </div>
        </div>
      </div>
    </Modal>
  );
};
